import React from 'react';
import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CSRFContext from '@seccon/core/contexts/csrf';

const useCreateSelectedPersonnel = () => {
  const queryClient = useQueryClient();
  const toastApi = React.useContext(ToastContext);
  const csrfToken = React.useContext(CSRFContext);
  return useMutation({
    mutationFn: ({ sessionId, selectedMappedIds }) => (
      fetch(`/personnelComparisonTool/${ sessionId }/missingPersonnel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'anti-csrf-token': csrfToken
        },
        body: JSON.stringify({ mappedIds: selectedMappedIds })
      }).then(decodeJson)
    ),
    onSuccess: () => {
      toastApi.success('Personnel record was created successfully.');
      queryClient.invalidateQueries(['personnelOverviewData']);
    },
    onError: ({ body }) => {
      toastApi.error(body && body?.message ? `Error: ${ body.message }` : 'Unable to update personnel. Please try again');
    }
  });
}

export default useCreateSelectedPersonnel;
